document.documentElement.classList.add("terra-js");

(function () {
  "use strict";

  var doc = document;
  var body = doc.body;
  var desktop = window.matchMedia("(min-width: 1181px)");

  function all(selector, root) {
    return Array.prototype.slice.call((root || doc).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function parseList(value) {
    return String(value || "")
      .split(/[\n,;]+/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function parseJsonResponse(response) {
    return response.json().catch(function () { return {}; }).then(function (payload) {
      if (!response.ok || payload.ok === false) throw new Error(payload.message || payload.error || "Request failed");
      return payload;
    });
  }

  function getItems(payload, names) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.data)) return payload.data;
    for (var i = 0; i < names.length; i += 1) {
      if (payload && Array.isArray(payload[names[i]])) return payload[names[i]];
      if (payload && payload.data && Array.isArray(payload.data[names[i]])) return payload.data[names[i]];
    }
    return [];
  }

  /* Progressive reveal */
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var revealGroupSelector = [
    ".terra-section-intro",
    ".terra-section-head",
    ".terra-section-heading",
    ".terra-home-section-head",
    ".terra-category-grid",
    ".terra-services-grid",
    ".terra-associati-grid",
    ".terra-news-grid",
    ".terra-document-grid",
    ".terra-blog-grid",
    ".terra-app-module-grid",
    ".terra-screen-grid",
    ".terra-metric-grid",
    ".terra-chart-grid",
    ".terra-final-journey__grid",
    ".terra-associate-benefits-grid",
    ".terra-disciplinari__principles",
    ".terra-code-principles",
    ".terra-trace__steps"
  ].join(",");
  var revealDirections = ["bottom", "right", "left", "bottom"];
  var revealExclusionSelector = "header, nav, footer, form, [data-terra-world], .terra-home-hero, .terra-internal-hero, .terra-page-hero, .terra-product-section, .terra-service-product-grid, [class*='checkout'], [class*='cart'], [class*='carousel'], [class*='slider']";
  var revealCardSelector = "article, li, [class*='card']";
  var editorialRevealSelector = [
    "main .terra-section-intro > *",
    "main .terra-section-head > *",
    "main .terra-section-heading > *",
    "main .terra-home-section-head > *",
    "main .terra-guardian-grid > *",
    "main .terra-editorial__grid > *",
    "main .terra-category-grid > *",
    "main .terra-services-grid > *",
    "main .terra-associati-grid > *",
    "main .terra-news-grid > *",
    "main .terra-document-grid > *",
    "main .terra-blog-grid > *",
    "main .terra-app-module-grid > *",
    "main .terra-code-principles > *",
    "main .terra-final-journey__grid > *"
  ].join(",");
  var revealMediaSelector = [
    ".terra-guardian-card__media img",
    ".terra-story-card__media img",
    ".terra-associato-card__media img",
    ".terra-document-card__media img",
    ".terra-blog-card__media img",
    ".terra-service-card__media img"
  ].join(",");
  var revealMediaExclusionSelector = ".terra-brand, .terra-world, [data-terra-world], .terra-product-section, .terra-service-product, [class*='checkout'], [class*='cart']";

  if (!designMode) {
    all(editorialRevealSelector).forEach(function (item) {
      if (!item.hasAttribute("data-reveal") && !item.closest(revealExclusionSelector) && !item.parentElement.closest("[data-reveal]")) {
        item.setAttribute("data-reveal", "");
      }
    });
  }

  var revealItems = all("[data-reveal]");

  function revealSection(item) {
    return item.closest("section, .shopify-section, main > div") || item.parentElement;
  }

  function prepareRevealDirections() {
    var editorialSections = [];

    revealItems.forEach(function (item) {
      var direction = "none";

      if (!item.closest(revealExclusionSelector)) {
        if (item.matches(revealCardSelector)) {
          direction = "card";
        } else {
          var section = revealSection(item);
          var sectionIndex = editorialSections.indexOf(section);
          if (sectionIndex === -1) {
            editorialSections.push(section);
            sectionIndex = editorialSections.length - 1;
          }
          direction = revealDirections[sectionIndex % revealDirections.length];
        }
      }

      item.setAttribute("data-terra-reveal-direction", direction);

      if (direction !== "none") {
        var mediaItems = item.matches(revealMediaSelector) ? [item] : all(revealMediaSelector, item);

        mediaItems.forEach(function (media) {
          var source = media.getAttribute("src") || "";
          var functionalAsset = /logo|badge|sigillo|marchio|qr|terra-node/i.test(source);

          if (!functionalAsset && !media.closest(revealMediaExclusionSelector)) {
            media.classList.add("terra-reveal-media");
          }
        });
      }
    });
  }

  function revealIsExcluded(item) {
    return !!item.closest(revealExclusionSelector);
  }

  function showRevealItems() {
    revealItems.forEach(function (item) {
      item.classList.remove("is-reveal-ready");
      item.classList.add("is-visible");
      item.style.removeProperty("--terra-reveal-delay");
    });
  }

  if (!("IntersectionObserver" in window) || reducedMotion || designMode) {
    showRevealItems();
  } else {
    var observer;
    try {
      prepareRevealDirections();
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var target = entry.target;
            var revealDelay = parseFloat(window.getComputedStyle(target).getPropertyValue("--terra-reveal-delay")) || 0;

            target.classList.add("is-visible");
            observer.unobserve(target);

            window.setTimeout(function () {
              target.classList.remove("is-reveal-ready");
              target.style.removeProperty("--terra-reveal-delay");
            }, 1350 + revealDelay);
          }
        });
      }, { rootMargin: "0px 0px -7% 0px", threshold: 0.08 });

      all(revealGroupSelector).forEach(function (group) {
        all(":scope > [data-reveal]", group).forEach(function (item, index) {
          if (!revealIsExcluded(item)) item.style.setProperty("--terra-reveal-delay", Math.min(index * 125, 500) + "ms");
        });
      });

      revealItems.forEach(function (item) {
        if (revealIsExcluded(item)) {
          item.classList.add("is-visible");
          return;
        }
        item.classList.add("is-reveal-ready");
        observer.observe(item);
      });
    } catch (error) {
      if (observer) observer.disconnect();
      showRevealItems();
    }
  }

  /* Navigation */
  var header = doc.querySelector("[data-site-header]");
  var menuToggle = doc.querySelector("[data-menu-toggle]");
  var menuPanel = doc.querySelector("[data-menu-panel]");
  var menuClosers = all("[data-menu-close]");
  var navItems = all("[data-nav-item]");

  function submenuParts(item) {
    return { button: item && item.querySelector("[data-submenu-toggle]"), panel: item && item.querySelector("[data-submenu]") };
  }

  function setSubmenu(item, open) {
    var parts = submenuParts(item);
    if (!parts.button || !parts.panel) return;
    parts.button.setAttribute("aria-expanded", open ? "true" : "false");
    parts.panel.hidden = !open;
    item.classList.toggle("is-open", open);
  }

  function closeSubmenus(except) {
    navItems.forEach(function (item) { if (item !== except) setSubmenu(item, false); });
  }

  function setMenu(open) {
    if (!menuToggle || !menuPanel) return;
    menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    menuPanel.classList.toggle("is-open", open);
    body.classList.toggle("terra-menu-open", open);
    menuClosers.forEach(function (closer) {
      if (closer.classList.contains("terra-nav-backdrop")) closer.hidden = !open;
    });
    if (open) {
      var closeButton = menuPanel.querySelector("[data-menu-close]");
      if (closeButton) window.setTimeout(function () { closeButton.focus(); }, 30);
    } else {
      closeSubmenus();
    }
  }

  if (menuToggle) menuToggle.addEventListener("click", function () { setMenu(menuToggle.getAttribute("aria-expanded") !== "true"); });
  menuClosers.forEach(function (button) { button.addEventListener("click", function () { setMenu(false); }); });

  navItems.forEach(function (item) {
    var parts = submenuParts(item);
    if (!parts.button) return;
    parts.button.addEventListener("click", function (event) {
      event.preventDefault();
      var open = parts.button.getAttribute("aria-expanded") !== "true";
      closeSubmenus(item);
      setSubmenu(item, open);
    });
    item.addEventListener("mouseenter", function () { if (desktop.matches) { closeSubmenus(item); setSubmenu(item, true); } });
    item.addEventListener("mouseleave", function () { if (desktop.matches) setSubmenu(item, false); });
    item.addEventListener("focusin", function () { if (desktop.matches) { closeSubmenus(item); setSubmenu(item, true); } });
  });

  all("[data-menu-panel] a").forEach(function (link) { link.addEventListener("click", function () { if (!desktop.matches) setMenu(false); }); });
  doc.addEventListener("click", function (event) { if (header && !header.contains(event.target)) closeSubmenus(); });
  doc.addEventListener("keydown", function (event) {
    if (event.key === "Escape") { setMenu(false); closeSubmenus(); }
    if (event.key === "Tab" && body.classList.contains("terra-menu-open") && menuPanel) {
      var focusable = all('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled])', menuPanel);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && doc.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && doc.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  if (desktop.addEventListener) desktop.addEventListener("change", function () { setMenu(false); });

  var locale = doc.querySelector("[data-locale-select]");
  if (locale) locale.addEventListener("change", function () { if (locale.form) locale.form.submit(); });

  /* PDF viewer */
  var modal = doc.querySelector("[data-pdf-modal]");
  var modalFrame = modal && modal.querySelector("[data-pdf-frame]");
  var modalDownload = modal && modal.querySelector("[data-pdf-download]");
  var returnFocus = null;

  function previewUrl(url) {
    var match = String(url || "").match(/drive\.google\.com\/file\/d\/([^/]+)/);
    return match ? "https://drive.google.com/file/d/" + match[1] + "/preview" : url;
  }

  function openPdf(url, trigger) {
    if (!modal || !url) return;
    returnFocus = trigger || doc.activeElement;
    if (modalFrame) modalFrame.src = previewUrl(url);
    if (modalDownload) modalDownload.href = url;
    modal.hidden = false;
    body.classList.add("terra-modal-open");
    var close = modal.querySelector("[data-pdf-close]");
    if (close) close.focus();
  }

  function closePdf() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (modalFrame) modalFrame.removeAttribute("src");
    body.classList.remove("terra-modal-open");
    if (returnFocus && returnFocus.focus) returnFocus.focus();
  }

  doc.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-pdf-open]");
    if (opener) { event.preventDefault(); openPdf(opener.getAttribute("data-pdf-url"), opener); }
    if (event.target.closest("[data-pdf-close]")) closePdf();
  });

  /* Public endpoints: forms and cards */
  all("[data-association-form]").forEach(function (form) {
    var endpoint = form.getAttribute("data-endpoint");
    var status = form.querySelector("[data-form-status]");
    var submit = form.querySelector('[type="submit"]');
    if (!endpoint || !/^https:\/\//i.test(endpoint)) return;
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var data = new FormData(form);
      if (String(data.get("website_check") || "").trim()) return;
      var payload = {};
      data.forEach(function (value, key) { payload[key] = value; });
      payload.submittedAt = new Date().toISOString();
      if (submit) submit.disabled = true;
      if (status) { status.textContent = form.getAttribute("data-sending-message") || "Invio in corso…"; status.className = "terra-form-status terra-field--full"; }
      fetch(endpoint, { method: "POST", mode: "cors", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(payload) })
        .then(parseJsonResponse)
        .then(function () { form.reset(); if (status) { status.textContent = form.getAttribute("data-success-message") || "Richiesta ricevuta."; status.classList.add("is-success"); } })
        .catch(function () { if (status) { status.textContent = form.getAttribute("data-error-message") || "Invio non riuscito."; status.classList.add("is-error"); } })
        .finally(function () { if (submit) submit.disabled = false; });
    });
  });

  function normalizeCategory(value) {
    return String(value || "altro").toLowerCase().trim().replace(/_/g, "-").replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
  }

  function resolvePublicUrl(value, base) {
    if (!value) return "";
    try {
      var parsed = new URL(String(value), base || window.location.href);
      return parsed.protocol === "https:" || parsed.protocol === "http:" ? parsed.href : "";
    } catch (error) {
      return "";
    }
  }

  all("[data-associates-grid]").forEach(function (memberGrid) {
    var endpoint = memberGrid.getAttribute("data-associates-endpoint");
    if (endpoint && /^https:\/\//i.test(endpoint)) {
      fetch(endpoint, { headers: { Accept: "application/json" } }).then(parseJsonResponse).then(function (payload) {
        var items = getItems(payload, ["associati", "members", "items", "results"]);
        if (!items.length) return;
        memberGrid.innerHTML = items.map(function (item) {
          var name = item.nome || item.name || item.companyName || "T.E.R.R.A.";
          var category = normalizeCategory(item.categoria || item.category || item.memberType);
          var logoImage = item.logoUrl || item.logo;
          var image = resolvePublicUrl(item.immagine || item.image || logoImage || memberGrid.getAttribute("data-fallback-logo"), endpoint);
          var location = [item.territorio || item.region, item.comune || item.city].filter(Boolean).join(" · ");
          var description = item.descrizioneBreve || item.shortDescription || item.description || "";
          var url = resolvePublicUrl(item.schedaUrl || item.profileUrl || item.url || "", endpoint);
          var linkLabel = memberGrid.getAttribute("data-associates-link-label") || "";
          var mediaClass = logoImage ? " terra-associato-card__media--logo" : "";
          var title = url ? '<a href="' + escapeHtml(url) + '">' + escapeHtml(name) + '</a>' : escapeHtml(name);
          return '<article class="terra-associato-card is-visible" data-associate-category="' + escapeHtml(category) + '"><div class="terra-associato-card__media' + mediaClass + '"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(name) + '" loading="lazy"></div><div class="terra-associato-card__body"><p class="terra-kicker">' + escapeHtml(item.categoriaLabel || item.categoryLabel || category.replace(/-/g, " ")) + '</p><h3>' + title + '</h3>' + (location ? '<p><strong>' + escapeHtml(location) + '</strong></p>' : '') + (description ? '<p>' + escapeHtml(description) + '</p>' : '') + (url && linkLabel ? '<a class="terra-text-link" href="' + escapeHtml(url) + '">' + escapeHtml(linkLabel) + ' <span aria-hidden="true">→</span></a>' : '') + '</div></article>';
        }).join("");
        memberGrid.setAttribute("data-associate-count", String(items.length));
      }).catch(function () { memberGrid.classList.add("is-fallback"); });
    }
  });

  var activeMemberFilter = "all";
  function filterMembers(value) {
    activeMemberFilter = value;
    all("[data-associate-category]").forEach(function (card) { card.hidden = value !== "all" && card.getAttribute("data-associate-category") !== value; });
    all("[data-associate-filter]").forEach(function (button) { button.classList.toggle("is-active", button.getAttribute("data-associate-filter") === value); });
  }
  all("[data-associate-filter]").forEach(function (button) { button.addEventListener("click", function (event) { event.preventDefault(); filterMembers(button.getAttribute("data-associate-filter") || "all"); }); });

  /* Accessible data filtering */
  all("[data-data-filter]").forEach(function (button) {
    button.addEventListener("click", function () {
      var value = button.getAttribute("data-data-filter");
      var dashboard = button.closest("[data-data-dashboard]") || doc;
      all("[data-data-category]", dashboard).forEach(function (item) { item.hidden = value !== "all" && item.getAttribute("data-data-category") !== value; });
      all("[data-data-filter]", dashboard).forEach(function (control) { control.classList.toggle("is-active", control === button); });
    });
  });

  all("[data-document-library]").forEach(function (library) {
    var search = library.querySelector("[data-document-search]");
    var buttons = all("[data-document-filter]", library);
    var cards = all("[data-document-card]", library);
    var empty = library.querySelector("[data-document-empty]");
    var filter = "all";
    function applyDocuments() {
      var query = String(search && search.value || "").trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var categoryMatch = filter === "all" || card.getAttribute("data-document-category") === filter;
        var textMatch = !query || String(card.getAttribute("data-document-search-text") || "").toLowerCase().indexOf(query) !== -1;
        card.hidden = !(categoryMatch && textMatch);
        if (!card.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    }
    buttons.forEach(function (button) { button.addEventListener("click", function () { filter = button.getAttribute("data-document-filter") || "all"; buttons.forEach(function (item) { item.classList.toggle("is-active", item === button); }); applyDocuments(); }); });
    if (search) search.addEventListener("input", applyDocuments);
  });

  all("[data-instagram-grid]").forEach(function (grid) {
    var endpoint = grid.getAttribute("data-instagram-endpoint");
    var profile = grid.getAttribute("data-instagram-profile") || "terraassociati";
    if (!endpoint || !/^https:\/\//i.test(endpoint)) return;
    fetch(endpoint, { headers: { Accept: "application/json" } }).then(parseJsonResponse).then(function (payload) {
      var posts = getItems(payload, ["posts", "items", "results"]);
      if (!posts.length) return;
      grid.innerHTML = posts.slice(0, 6).map(function (post) {
        var image = post.image || post.imageUrl || post.media_url || post.thumbnail_url || "";
        var caption = post.caption || post.description || "";
        var url = post.permalink || post.url || "https://www.instagram.com/" + profile + "/";
        return '<article class="terra-story-card is-visible"><a class="terra-story-card__media" href="' + escapeHtml(url) + '" target="_blank" rel="noopener noreferrer">' + (image ? '<img src="' + escapeHtml(image) + '" alt="Instagram @' + escapeHtml(profile) + '" loading="lazy">' : '') + '</a><div><p class="terra-kicker">@' + escapeHtml(profile) + '</p><p>' + escapeHtml(caption).slice(0, 190) + '</p></div></article>';
      }).join("");
    }).catch(function () { grid.classList.add("is-fallback"); });
  });

  /* Lightweight charts. The visible table remains the source and fallback. */
  all("[data-chart]").forEach(function (chart) {
    var values = parseList(chart.getAttribute("data-values")).map(Number).filter(function (value) { return Number.isFinite(value); });
    var labels = parseList(chart.getAttribute("data-labels"));
    var svg = chart.querySelector("[data-chart-svg]");
    if (!svg || !values.length || values.length !== labels.length) return;
    var max = Math.max.apply(null, values.concat([1]));
    var min = Math.min.apply(null, values.concat([0]));
    var range = max - min || 1;
    var type = chart.getAttribute("data-chart-type") || "line";
    var content = '<line class="axis" x1="8" y1="92" x2="96" y2="92"></line><line class="axis" x1="8" y1="8" x2="8" y2="92"></line>';
    if (type === "bar") {
      var width = 78 / values.length;
      values.forEach(function (value, index) { var height = ((value - min) / range) * 72; var x = 12 + index * width; content += '<rect class="bar" x="' + x + '" y="' + (88 - height) + '" width="' + Math.max(width - 3, 2) + '" height="' + height + '"><title>' + escapeHtml(labels[index]) + ': ' + value + '</title></rect>'; });
    } else {
      var points = values.map(function (value, index) { var x = values.length === 1 ? 52 : 10 + (index * 84 / (values.length - 1)); var y = 88 - ((value - min) / range) * 72; return [x, y]; });
      content += '<polyline class="series" points="' + points.map(function (point) { return point.join(","); }).join(" ") + '"></polyline>';
      points.forEach(function (point, index) { content += '<circle class="marker" cx="' + point[0] + '" cy="' + point[1] + '" r="2"><title>' + escapeHtml(labels[index]) + ': ' + values[index] + '</title></circle>'; });
    }
    svg.innerHTML = content;
  });

  /* Service booking */
  function isoDate(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, "0");
    var d = String(date.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + d;
  }

  function dateFromIso(value) {
    var parts = String(value).split("-").map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
  }

  function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
  }

  all("[data-booking-form]").forEach(function (form) {
    var dateInput = form.querySelector("[data-booking-date]");
    var slotsInput = form.querySelector("[data-booking-slots]");
    var variantInput = form.querySelector('[name="id"]');
    var modes = all("[data-booking-mode]", form);
    var status = form.querySelector("[data-booking-status]");
    var priceOutput = form.querySelector("[data-summary-price]");
    var baseOutput = form.querySelector("[data-summary-base]");
    var supplementOutput = form.querySelector("[data-summary-supplement]");
    var modeOutput = form.querySelector("[data-summary-mode]");
    var dateOutput = form.querySelector("[data-summary-date]");
    var modeProperty = form.querySelector('[name="properties[Modalità]"]');
    var storeDate = dateFromIso(form.getAttribute("data-store-date"));
    var minDays = Number(form.getAttribute("data-min-days") || 7);
    var maxDays = Number(form.getAttribute("data-max-days") || 120);
    var urgentDays = Math.ceil(Number(form.getAttribute("data-urgent-hours") || 48) / 24);
    var closedWeekdays = parseList(form.getAttribute("data-closed-weekdays")).map(Number);
    var closedDates = parseList(form.getAttribute("data-closed-dates"));
    var slotsEndpoint = form.getAttribute("data-slots-endpoint");
    var staticSlots = slotsInput ? slotsInput.innerHTML : "";

    function isClosed(value) {
      if (!value) return false;
      var date = dateFromIso(value);
      return closedWeekdays.indexOf(date.getDay()) !== -1 || closedDates.indexOf(value) !== -1;
    }

    function nextOpen(date, direction, limit) {
      var candidate = new Date(date.getTime());
      var attempts = 0;
      while (isClosed(isoDate(candidate)) && attempts < (limit || 45)) { candidate = addDays(candidate, direction); attempts += 1; }
      return candidate;
    }

    function updateMode(mode) {
      var urgent = mode.getAttribute("data-urgent") === "true";
      if (variantInput) variantInput.value = mode.value;
      if (modeProperty) modeProperty.value = mode.getAttribute("data-mode-label") || (urgent ? "Urgente" : "Standard");
      var min = urgent ? storeDate : addDays(storeDate, minDays);
      var max = urgent ? addDays(storeDate, urgentDays) : addDays(storeDate, maxDays);
      min = nextOpen(min, 1);
      max = nextOpen(max, -1);
      if (dateInput) { dateInput.min = isoDate(min); dateInput.max = isoDate(max); dateInput.value = ""; }
      if (priceOutput) priceOutput.textContent = mode.getAttribute("data-price-formatted") || "";
      if (baseOutput) baseOutput.textContent = mode.getAttribute("data-base-price") || "";
      if (supplementOutput) supplementOutput.textContent = mode.getAttribute("data-supplement") || "";
      if (modeOutput) modeOutput.textContent = mode.getAttribute("data-mode-label") || "";
      if (dateOutput) dateOutput.textContent = "—";
      if (status) status.textContent = urgent ? form.getAttribute("data-urgent-info") : form.getAttribute("data-standard-info");
    }

    modes.forEach(function (mode) { mode.addEventListener("change", function () { if (mode.checked) updateMode(mode); }); });
    function loadSlots() {
      if (!slotsInput || !slotsEndpoint || !/^https:\/\//i.test(slotsEndpoint) || !dateInput.value) return;
      var url;
      try { url = new URL(slotsEndpoint); } catch (error) { return; }
      url.searchParams.set("product_id", form.getAttribute("data-product-id") || "");
      url.searchParams.set("variant_id", variantInput && variantInput.value || "");
      url.searchParams.set("date", dateInput.value);
      slotsInput.disabled = true;
      fetch(url.toString(), { headers: { Accept: "application/json" } }).then(parseJsonResponse).then(function (payload) {
        if (payload.available === false) throw new Error("Unavailable");
        var slots = getItems(payload, ["slots", "items", "results"]);
        if (!slots.length) throw new Error("No slots");
        slotsInput.innerHTML = '<option value="">—</option>' + slots.map(function (slot) {
          var value = typeof slot === "string" ? slot : (slot.value || slot.time || slot.label || "");
          var label = typeof slot === "string" ? slot : (slot.label || slot.time || slot.value || "");
          var disabled = typeof slot === "object" && slot.available === false;
          return '<option value="' + escapeHtml(value) + '"' + (disabled ? ' disabled' : '') + '>' + escapeHtml(label) + '</option>';
        }).join("");
      }).catch(function () {
        slotsInput.innerHTML = staticSlots;
        if (status) status.textContent = form.getAttribute("data-date-error") || "Data non disponibile";
      }).finally(function () { slotsInput.disabled = false; });
    }

    if (dateInput) dateInput.addEventListener("change", function () {
      if (isClosed(dateInput.value)) { dateInput.setCustomValidity(form.getAttribute("data-date-error") || "Data non disponibile"); dateInput.reportValidity(); dateInput.value = ""; }
      else { dateInput.setCustomValidity(""); if (dateOutput) dateOutput.textContent = dateInput.value || "—"; loadSlots(); }
    });
    form.addEventListener("submit", function (event) {
      var selected = form.querySelector("[data-booking-mode]:checked");
      if (!selected || !dateInput || !dateInput.value || isClosed(dateInput.value)) { event.preventDefault(); if (status) status.textContent = form.getAttribute("data-date-error") || "Scegli una data valida."; if (dateInput) dateInput.focus(); }
    });
    var selected = form.querySelector("[data-booking-mode]:checked") || modes[0];
    if (selected) { selected.checked = true; updateMode(selected); }
  });
})();
